import { Component, inject, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TechnischeResourceInformationen } from '../../../domain/model/technische-resource-informationen.model';
import { AbstractForm } from '../abstract-form.model';
import { FormGroupConfig } from '../form-config.model';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';
import { EnergietraegerTypeItem } from '../../../domain/model/energietraeger-type.enum';
import { Feld } from '../../../domain/model/feld.enum';
import { PostalCodeValidator } from '../validator/postal-code.validator';
import { PostalCodeType } from '../../../domain/model/postal-code-type.enum';

@Component({
    selector: 'redispatch-technische-resource-sub-form',
    templateUrl: './technische-resource-sub-form.component.html',
    styleUrls: [
        './technische-resource-sub-form.component.scss',
    ],
    standalone: false,
})
export class TechnischeResourceSubFormComponent extends AbstractForm<TechnischeResourceInformationen> {
    public static readonly SHARED_ANLAGENBETREIBER_NAME_VALIDATOR = MatValidators.required;
    public static readonly SHARED_ANLAGENBETREIBER_PLZ_VALIDATOR = PostalCodeValidator.validate(PostalCodeType.OTHER);
    public static readonly SHARED_ANLAGENBETREIBER_ORT_VALIDATOR = MatValidators.required;

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;

    public readonly MASTREGNR_LENGTH = 15;
    public readonly SPEICHER_SEPARATOR = ',';

    @Input({ required: true }) disabled: boolean;
    @Input({ required: true }) readonly: boolean;

    public readonly EnergietraegerTypeItems = EnergietraegerTypeItem.getAll();
    public readonly Feld = Feld;

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<TechnischeResourceInformationen> {
        return {
            maStRegNr: [
                {
                    value: '',
                    disabled: this.disabled || this.readonly,
                },
                [
                    Validators.minLength(this.MASTREGNR_LENGTH),
                    Validators.maxLength(this.MASTREGNR_LENGTH),
                ],
            ],
            anlagenType: [
                { value: null, disabled: this.disabled || this.readonly },
                MatValidators.required,
            ],
            zuordnungSpeicher: [
                { value: [], disabled: this.disabled || this.readonly },
            ],
            anlagebetreiberName: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                TechnischeResourceSubFormComponent.SHARED_ANLAGENBETREIBER_NAME_VALIDATOR,
            ],
            anlagebetreiberStrasse: [
                { value: null, disabled: this.disabled || this.readonly },
            ],
            anlagebetreiberHausnummer: [
                { value: null, disabled: this.disabled || this.readonly },
            ],
            anlagebetreiberHausnummerZusatz: [
                { value: null, disabled: this.disabled || this.readonly },
            ],
            anlagebetreiberPLZ: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                [
                    MatValidators.required,
                    TechnischeResourceSubFormComponent.SHARED_ANLAGENBETREIBER_PLZ_VALIDATOR,
                ],
            ],
            anlagebetreiberOrt: [
                {
                    value: null,
                    disabled: this.disabled || this.readonly,
                },
                TechnischeResourceSubFormComponent.SHARED_ANLAGENBETREIBER_ORT_VALIDATOR,
            ],
        };
    }

    public sanitize(infos: TechnischeResourceInformationen): TechnischeResourceInformationen {
        return infos;
    }

}
